import { render } from "./SelectAmount.vue?vue&type=template&id=1ba4a3ea&ts=true"
import script from "./SelectAmount.vue?vue&type=script&lang=ts"
export * from "./SelectAmount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__